var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 modal-thing px-2" },
    [
      _c(
        "div",
        { staticClass: "d-none d-md-flex justify-content-center mb-5 pb-4" },
        [
          _c("img", {
            staticClass: "mx-auto",
            staticStyle: { "max-width": "300px" },
            attrs: { src: _vm.educationImage },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mb-4 text-center" }, [
        _c("p", { staticClass: "font-weight-bold font-size-200 mb-0" }, [
          _vm._v(_vm._s(_vm._f("trans")("Claim educational access"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "bg-education text-white py-2 px-4 text-center d-flex align-items-center justify-content-between gap-75 br-4 mb-4",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-inline-flex justify-content-center align-items-center gap-75 flex-wrap",
            },
            [
              _c("i", { staticClass: "far fa-graduation-cap font-size-200" }),
              _vm._v(" "),
              _c("span", { domProps: { innerHTML: _vm._s(_vm.description) } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "gap-75 d-inline-flex align-items-center justify-content-center flex-wrap",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "text-white text-underline",
                      attrs: { href: _vm.linkEducation },
                    },
                    [_vm._v(_vm._s(_vm._f("trans")("Learn more")))]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("ButtonWithLoadingState", {
        staticClass:
          "btn btn-warning btn-lg btn-block font-weight-bold text-uppercase rounded",
        attrs: {
          text: _vm._f("trans")("Claim now"),
          "is-state-loading": _vm.stateLoading,
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.claimEducational.apply(null, arguments)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }